<template>
  <div>
    <section class="hero is-small is-primary">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-2">
            {{ title }}
          </h1>
          <h2 class="subtitle is-4">
            {{ subtitle }}
          </h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container is-fluid">
        <vue-simple-markdown :source="body"></vue-simple-markdown>
      </div>
    </section>
  </div>
</template>

<script>
import Database from "@/services/Database";
export default {
  name: "project",
  data() {
    return {
      title: "",
      subtitle: "",
      body: "",
      projectData: []
    };
  },
  mounted: function() {
    let self = this;
    async function getProject() {
      try {
        const response = await Database.getProject(self.$route.params.slug);
        self.title = response.data.records[0].fields.Title;
        self.subtitle = response.data.records[0].fields.Subtitle;
        self.body = response.data.records[0].fields.Body;
      } catch (err) {}
    }
    getProject();
  }
};
</script>

<style>
.markdown-body li {
  list-style: disc outside none;
}

.markdown-body img {
  display: table-caption;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.markdown-body img + i {
  font-style: normal;
  display: inherit;
  text-align: center;
  font-size: 90%;
  line-height: normal;
}
</style>
